import { render, staticRenderFns } from "./menu4.vue?vue&type=template&id=42e8696e&scoped=true&"
import script from "./menu4.vue?vue&type=script&lang=js&"
export * from "./menu4.vue?vue&type=script&lang=js&"
import style0 from "./menu4.vue?vue&type=style&index=0&id=42e8696e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e8696e",
  null
  
)

export default component.exports